import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Header.css';

// TODO: replace with the real LMS subdomain once the LMS site is built.
const LMS_URL = 'https://lms.mindspaindia.com';

const NAV = [
  {
    label: 'About',
    path: '/about',
    items: [
      { label: 'Our Team', path: '/about#team' },
      { label: 'Our Space', path: '/about#space' },
      { label: 'Gallery', path: '/gallery' },
      { label: 'Awards & Certificates', path: '/awards' },
    ],
  },
  {
    label: 'Services',
    path: '/services',
  },
  {
    label: 'Events',
    path: '/events',
    items: [
      { label: 'Upcoming Events', path: '/events' },
      { label: 'Past Events', path: '/events#past' },
    ],
  },
  {
    label: 'Resources',
    path: '/blogs',
    items: [
      { label: 'Blogs', path: '/blogs' },
      { label: 'Books', path: '/books' },
    ],
  },
  {
    label: 'Testimonials',
    path: '/testimonials',
    items: [
      { label: 'Client Testimonials', path: '/testimonials#client' },
      { label: 'Trainee Testimonials', path: '/testimonials#trainee' },
      { label: 'Reviews', path: '/testimonials#reviews' },
    ],
  },
  {
    label: 'Contact',
    path: '/contact',
    items: [
      { label: 'WhatsApp', path: 'https://wa.me/919140395816', external: true },
      { label: 'Location', path: '/contact#location' },
    ],
  },
];

const Chevron = () => (
  <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openMobileDropdown, setOpenMobileDropdown] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setIsMobileMenuOpen(false);
    setOpenMobileDropdown(null);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const isSectionActive = (section) => {
    return section.path === location.pathname ||
      location.pathname.startsWith(section.path + '/') ||
      (section.items || []).some(i => !i.external && location.pathname === i.path.split('#')[0].split('?')[0]);
  };

  const renderMenuLink = (item) => {
    if (item.external) {
      return (
        <a
          key={item.label}
          href={item.path}
          target="_blank"
          rel="noopener noreferrer"
          className="header__dropdown-item"
        >
          {item.label}
        </a>
      );
    }
    if (item.path.includes('#') || item.path.includes('?')) {
      return (
        <a key={item.label} href={item.path} className="header__dropdown-item">
          {item.label}
        </a>
      );
    }
    return (
      <Link key={item.label} to={item.path} className="header__dropdown-item">
        {item.label}
      </Link>
    );
  };

  return (
    <header className="header">
      <div className="header__inner">
        <Link to="/" className="header__logo" aria-label="Mind Spa — home">
          <img src="/logo.png" alt="" className="header__logo-img" />
          <span className="header__logo-brand">Mind Spa</span>
        </Link>

        <nav className={`header__nav ${isMobileMenuOpen ? 'header__nav--open' : ''}`} aria-label="Primary">
          <Link to="/" className={`header__nav-link ${location.pathname === '/' ? 'active' : ''}`}>
            Home
          </Link>

          {NAV.map((section) => {
            if (!section.items || section.items.length === 0) {
              return (
                <Link
                  key={section.label}
                  to={section.path}
                  className={`header__nav-link ${isSectionActive(section) ? 'active' : ''}`}
                >
                  {section.label}
                </Link>
              );
            }
            return (
              <div key={section.label} className="header__nav-dropdown">
                <button
                  type="button"
                  className={`header__nav-link header__nav-link--dropdown ${isSectionActive(section) ? 'active' : ''}`}
                  onClick={() => {
                    if (window.innerWidth <= 900) {
                      setOpenMobileDropdown(
                        openMobileDropdown === section.label ? null : section.label
                      );
                    } else {
                      navigate(section.path);
                    }
                  }}
                >
                  {section.label}
                  <Chevron />
                </button>
                <div
                  className={`header__dropdown-menu ${
                    openMobileDropdown === section.label ? 'header__dropdown-menu--open' : ''
                  }`}
                >
                  {section.items.map(renderMenuLink)}
                </div>
              </div>
            );
          })}

          <a
            href={LMS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="header__nav-link"
          >
            Courses
            <svg className="header__nav-extlink" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M7 17L17 7M9 7h8v8" />
            </svg>
          </a>
        </nav>

        {/* Quiet booking link — text only, with arrow */}
        <Link to="/contact" className="header__book-link">
          Book a session
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"/>
            <polyline points="12 5 19 12 12 19"/>
          </svg>
        </Link>

        <button
          className={`header__hamburger ${isMobileMenuOpen ? 'header__hamburger--active' : ''}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
